import store from '../store';

/**
 * 大模型接口API
 */
export default {
    /**
     * 获取大模型线路列表
     */
    async getLLNList () {
        let token = store.state.account.token;
        const API = '/call-platform/common/llms';
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },
    /**
     * 获取大模型服务节点列表
     */
    async getHostList (modelName) {
        let token = store.state.account.token;
        const API = '/call-platform/pciTransGptHost/list?modelName=' + modelName;
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'GET', headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    },

    /**
     * 更新大模型状态
     */
    async updateStatus (payload) {
        let token = store.state.account.token;
        const API = '/call-platform/pciTransGptHost/updateStatus';
        let body = JSON.stringify(payload);
        let headers = { 'Content-Type': 'application/json', 'Authorization': token };
        let resp = await fetch(API, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`接口【${API}】请求失败`);
        }
        let ret = await resp.json();

        // 401表示token过期，需要重新登录
        if (ret.statusCode === 401) {
            store.commit('account/logout');
            return;
        }
        // 其他错误
        if (ret.statusCode !== 200) {
            throw new Error(ret.opDesc);
        }
        return ret;
    }
};
